import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const fetchStoragePlan = async (params = {}) => {
  try {
    let bodyParams = reqTransform.fetchStoragePlan(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/StoragePlan/FetchConversionsAgainstPlan`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(bodyParams),
    }).ready;
    const resData = await utils.processApiRes(res);
    // console.log('ResData', resData, res);
    return resTransform.fetchStoragePlan(resData);
  } catch (err) {
    console.log('FetchStorageLevelsAgainstStorageId-fetchList->err---->', err);

    const errors = await utils.processApiErrors(err, '', 'FetchStorageLevelsAgainstStorageId');
    throw errors;
  }
};
